import React, { useState } from 'react';
import styles from './FaqPage.module.css';
import { useTranslation, Trans } from 'react-i18next';

const FaqPage = () => {
  const [openKey, setOpenKey] = useState('0-0');
  const { t } = useTranslation('faq');

  const faqSections = [
    {
      title: <><img src="/icons/ticket.svg" alt={t('sections.ticket.ticketAlt')} style={{width: '1.2em', verticalAlign: 'middle', marginRight: '0.3em'}} />{t('sections.ticket.title')}</>,
      items: t('sections.ticket.items', { returnObjects: true }),
    },
    {
      title: t('sections.eticket.title'),
      items: t('sections.eticket.items', { returnObjects: true }),
    },
    {
      title: t('sections.payment.title'),
      items: t('sections.payment.items', { returnObjects: true }),
    },
    {
      title: t('sections.event.title'),
      items: t('sections.event.items', { returnObjects: true }),
    },
    {
      title: t('sections.seller.title'),
      items: t('sections.seller.items', { returnObjects: true }),
    },
    {
      title: <><img src="/icons/image.svg" alt={t('sections.gallery.galleryAlt')} style={{width: '1.2em', verticalAlign: 'middle', marginRight: '0.3em'}} />{t('sections.gallery.title')}</>,
      items: t('sections.gallery.items', { returnObjects: true }),
    },
    {
      title: <><img src="/icons/pin.svg" alt={t('sections.venue.venueAlt')} style={{width: '1.2em', verticalAlign: 'middle', marginRight: '0.3em'}} />{t('sections.venue.title')}</>,
      items: t('sections.venue.items', { returnObjects: true }),
    },
    {
      title: <><img src="/icons/key.svg" alt={t('sections.account.accountAlt')} style={{width: '1.2em', verticalAlign: 'middle', marginRight: '0.3em'}} />{t('sections.account.title')}</>,
      items: t('sections.account.items', { returnObjects: true }),
    },
    {
      title: t('sections.other.title'),
      items: t('sections.other.items', { returnObjects: true }),
    },
  ];

  const toggle = (key) => {
    setOpenKey((prev) => (prev === key ? '' : key));
  };

  return (
    <div className={styles.container}>
      <div className={styles.hero}>
        <h1 className={styles.title}>{t('pageTitle')}</h1>
        <p className={styles.subtitle}>
          {t('pageSubtitle')}{' '}
          <Trans i18nKey="contactText" ns="faq" components={{ lnk: <a href="/contact" className={styles.mailLink} /> }} />
        </p>
      </div>

      {faqSections.map((section, sectionIndex) => (
        <section key={section.title} className={styles.section}>
          <h2 className={styles.sectionTitle}>{section.title}</h2>
          {section.items.map((item, itemIndex) => {
            const itemKey = `${sectionIndex}-${itemIndex}`;
            const isOpen = openKey === itemKey;

            return (
              <div key={item.q} className={styles.qaItem}>
                <button
                  type="button"
                  className={styles.qButton}
                  onClick={() => toggle(itemKey)}
                  aria-expanded={isOpen}
                >
                  <span className={styles.q}>Q. {item.q}</span>
                  <span className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}>▾</span>
                </button>

                {isOpen && (
                  <p className={styles.a}>
                    A. {item.linkHref && item.linkText
                      ? item.a.split(item.linkText).flatMap((part, i, arr) =>
                          i < arr.length - 1
                            ? [part, <a key={i} href={item.linkHref} className={styles.mailLink}>{item.linkText}</a>]
                            : [part]
                        )
                      : item.a
                    }
                  </p>
                )}
              </div>
            );
          })}
        </section>
      ))}
    </div>
  );
};

export default FaqPage;
